import type { TitledItem } from './TitledListSection';
import { TitledListSection } from './TitledListSection';
import {
  useRorosCompanyPrinciples,
  useRorosCompanyPrincipleCreate,
  useRorosCompanyPrincipleUpdate,
  useRorosCompanyPrincipleRemove,
  useRorosCompanyPrincipleReorder,
} from '@/hooks/roros/overarching';
import type { RorosCompanyPrincipleDTO } from '@/types/roros/overarching';
import { t } from '@/lib/i18n';

export function PrinciplesSection() {
  const q = useRorosCompanyPrinciples({ pageSize: '100' });
  const items = ((q.data as unknown) ?? []) as RorosCompanyPrincipleDTO[];
  return (
    <TitledListSection<RorosCompanyPrincipleDTO>
      title={t('Company Principles')}
      subtitle={t("Your company's operating principles — how your team works and decides.")}
      emptyHint={t('No principles yet.')}
      items={items}
      useCreate={useRorosCompanyPrincipleCreate}
      useUpdate={useRorosCompanyPrincipleUpdate}
      useRemove={useRorosCompanyPrincipleRemove}
      useReorder={useRorosCompanyPrincipleReorder}
      includeImage
    />
  );
}
